import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  title?: string;
  actions?: ReactNode;
}

export function Card({ children, className = '', title, actions }: CardProps) {
  return (
    <div className={`bg-card border border-border rounded-lg ${className}`}>
      {(title || actions) && (
        <div className="px-4 py-5 sm:px-6 border-b border-border flex justify-between items-center">
          {title && <h3 className="text-lg font-semibold text-card-foreground">{title}</h3>}
          {actions && <div>{actions}</div>}
        </div>
      )}
      <div className="px-4 py-5 sm:p-6">{children}</div>
    </div>
  );
}
